import axios from "axios";
import { Base_URL } from "../url";

export const fetchProjects = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetAllProjects`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching projects!";
  }
};

export const fetchProjectsByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetProjectsByOrg/${orgId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching projects by organization!";
  }
};

export const fetchProjectDetails = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetProjectById/${projectId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project details!";
  }
};

export const updateProject = async (projectId, projectData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/ProjectMaster/UpdateProject/${projectId}`,
      projectData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating project!";
  }
};

export const downloadProjectsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProjectMaster/ExportProjectsToExcel`,
      null,
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading projects data!";
  }
};
